module.exports = __webpack_public_path__ + "img/star.7f786e27.svg";